<template>
    <loading v-model:active="isLoading" :can-cancel="false" :on-cancel="onCancel" :is-full-page="fullPage" />
    <div class="container-fluid">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><router-link to="/">Início</router-link></li>
                <li class="breadcrumb-item active" aria-current="page">Meus contratos / {{ client.name }}</li>
            </ol>
        </nav>
        <div class="row" v-if="enable_error_list">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="alert alert-danger">
                    <ol>
                        <li v-for="(error, index) in errors" :key="index">{{ error[0] }}</li>
                    </ol>
                </div>
            </div>
        </div>
        <div class="row mt-4">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="tab-content">
                    <div class="tab-pane active" role="tabpanel" id="info">
                        <div class="card shadow mb-4">
                            <!-- Card Header - Dropdown -->
                            <div class="card-body"
                                :class="client_services_saved.length <= 0 ? 'card-body-no-spaccing' : ''">
                                <div
                                    class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                                    <h6 class="m-0 font-weight-bold text-primary">Serviços contratados</h6>
                                </div>
                                <div class="row">
                                    <div class="col-xl-12 col-md-12 col-sm-12">
                                        <div class="table-responsive">
                                            <table class="table" id="dataTable" width="100%" cellspacing="0">
                                                <thead>
                                                    <tr>
                                                        <th>Descrição</th>
                                                        <th class="text-center">Valor</th>
                                                        <th class="text-center">Colaboradores</th>
                                                        <th class="text-center">Pró-labore</th>
                                                        <th class="text-center">Emissão NF</th>
                                                        <th class="text-center">Contrato</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(service) in client_services_saved" :key="service.id">
                                                        <td class="align-middle">{{ service.name_service }} <br>
                                                            <span v-if="service.date_start_contract != ''"
                                                                class="badge badge-info mr-2">Início contrato:
                                                                {{ service.date_start_contract_formatted }} </span>
                                                            <span v-if="service.date_end_contract != ''"
                                                                class="badge badge-info mr-2">Validade:
                                                                {{ service.date_end_contract_formatted }}</span>
                                                            <span v-if="service.date_renovation_contract != ''"
                                                                class="badge badge-danger mr-2">Renovação:
                                                                {{ service.date_renovation_contract_formatted }}</span>
                                                            <span v-if="service.recurrence"
                                                                class="badge badge-success">Tipo: Recorrente</span>
                                                            <span v-if="!service.recurrence"
                                                                class="badge badge-warning">Tipo: Avulso</span>
                                                        </td>
                                                        <td class="text-center">{{ service.amount_formatted }}
                                                        </td>
                                                        <td class="text-center">{{ service.employees }} </td>
                                                        <td class="text-center">
                                                            <span class="badge badge-success"
                                                                v-if="service.pro_labore">Sim</span>
                                                            <span class="badge badge-danger" v-else>Não</span>
                                                        </td>
                                                        <td class="text-center">
                                                            <span class="badge badge-success"
                                                                v-if="service.emission_nf">Sim</span>
                                                            <span class="badge badge-danger" v-else>Não</span>
                                                        </td>
                                                        <td class="text-center"><button class="btn btn-link pointer"
                                                                @click="showModalViewContract">Contrato</button></td>
                                                    </tr>

                                                    <tr v-show="client_services_saved.length <= 0">
                                                        <td colspan="8" class="text-center">Nenhum registro encontrado
                                                        </td>
                                                    </tr>
                                                    <tr v-show="client_services_saved.length > 0">

                                                        <td colspan="9" class="text-left">Total em serviços: <strong>
                                                                {{ total_service }}</strong></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div id="modalDisplayViewContract" class="modal" :style="{ display: modalDisplayViewContract }">
        <div class="row">
            <div class="col-lg-12 col-sm-12 col-xs-12">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4>Dados do contrato</h4>
                        <button type="button" class="close" @click="closeModalViewContract()">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div ref="editor" class="editor-content" contenteditable="true" v-html="contract">
                  </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-danger" @click="closeModalViewContract()"><i class="fa fa-times"></i> Fechar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/api';
import { handleRequestErrors } from '@/handleErrors';
import { capitalize } from '@/util';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import { contrato } from '@/contrato/texto'
import { parseTemplate } from '../templateParser';


export default {
    components: { Loading },
    data() {
        return {
            isLoading: true,
            fullPage: true,
            client: {},
            client_services_saved: {},
            client_id: '',
            total_service: 0.00,
            modalDisplayViewContract: 'none',
            contract: '',
            client_service: {
                id: '',
                service_id: '',
                employees: '',
                pro_labore: '',
                emission_nf: '',
                signed_contract: '',
                client_service_id: '',
                amount: '',
                recurrence: '',
                date_start_contract: '',
                date_end_contract: '',
                date_renovation_contract: '',
                observation: ''
            },

            enable_error_list: false,
            errors: [],

        }
    },

    computed: {
        isDisabled: function () {
            return this.client_service.service_id != '' && this.client_service.amount != '' && this.client_service.recurrence != '';
        }
    },
    beforeMount() {
        const id = localStorage.getItem('client_id');
        this.client.id = id;
        this.getServiceClient();
    },

    methods: {
        onCancel() { },
        cancel() {
            this.action_save = false;
            this.client_service = { service_id: '', employees: '', pro_labore: '', emission_nf: '', signed_contract: '', recurrence: '' };
            this.client_services_saved = {};
            this.getServiceClient();

        },

        setCapitalize(text) {
            return capitalize(text);
        },

        formatReal(value) {
            return new Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: 'BRL'
            }).format(value);
        },

        calculateTotalServices() {
            let sum = 0;
            this.client_services_saved.forEach(service => {
                sum += parseFloat(service.amount);
            });

            this.total_service = this.formatReal(sum);
        },


        getServiceClient() {
            this.isLoading = true;
            api.get('/client-user/' + this.client.id + '/service')
                .then((response) => {
                    this.isLoading = false;
                    this.client = response.data.client;
                    this.client_services_saved = response.data.services_client;
                    this.calculateTotalServices();
                }).catch(error => {
                    this.isLoading = false;
                    handleRequestErrors(error.status, error);
                })
        },
        loadContract() {
            const total_service_formatted = this.total_service
            let endereco = this.client.street + ', Nº ' + this.client.number_street + ' - Bairro ' + this.client.district + ' - ' + this.client.city + '/' + this.client.uf;
            this.contract = parseTemplate(contrato, {
                mensalidade: total_service_formatted,
                nome: this.client.name,
                cnpj: this.client.document,
                endereco: endereco

            });
        },
        showModalViewContract() {
            this.loadContract();
            this.modalDisplayViewContract = 'block';
        },
        closeModalViewContract() {
            this.modalDisplayViewContract = 'none';
        },
    }
}
</script>

<style>
.editor-content {
  padding: 20px;
  min-height: 160px;
  max-height: 500px;
  outline: none;
  line-height: 1.6;
  font-size: 16px;
  overflow-y: auto;
  background: #fff;
  overflow-y: scroll;
  border: 1px solid rgba(0,0,0,0.1);
}

/* Estilização interna */
.editor-content h1 {
  font-size: 24px;
  margin-bottom: 16px;
}

.editor-content p {
  margin-bottom: 12px;
}
</style>